export type SelectOption = {
  name: string
  value: any
}

export const convertToSelectOptions = (data: any[], nameProp: string = 'name', valueProp: string = 'id'): SelectOption[] => {
  return data?.reduce((prev, cur) => {
    return [...prev, convertToSelectOption(cur, nameProp, valueProp)]
  }, [])
}

export const convertToSelectOption = (data: any, nameProp: string = 'name', valueProp: string = 'id'): SelectOption => {
  return {
    name: data ? data[nameProp] : '',
    value: data ? data[valueProp] : null
  }
}

export type AdditionalSelectOption = SelectOption & {
  additional: number | string | boolean | undefined
}

export const convertToAdditionalSelectOptions = (data: any[], nameProp: string = 'name', valueProp: string = 'id'): AdditionalSelectOption[] => {
  return data?.reduce((prev, cur) => {
    return [...prev, convertToSelectOption(cur, nameProp, valueProp)]
  }, [])
}

export const convertToAdditionalSelectOption = (data: any, nameProp: string = 'name', valueProp: string = 'id'): AdditionalSelectOption => {
  return {
    name: data ? data[nameProp] : '',
    value: data ? data[valueProp] : null,
    additional: data ? data : null
  }
}